import { createApi } from '@reduxjs/toolkit/query/react'

import { getFirebase } from '~/firebase'

import { apiPrivate } from '~/redux/utils/hom-api'

import { CraneGameLevelData, ShipState } from './types'

interface Response {
  success: boolean
}

export const craneGameApi = createApi({
  reducerPath: 'craneGameApi',
  tagTypes: ['craneGameData', 'CraneGame', 'shipState'],
  baseQuery: apiPrivate,

  endpoints: (build) => ({
    setCraneGameData: build.mutation<Response, CraneGameLevelData>({
      queryFn: async (args) => {
        const { levelName, boxesDestroyed, boxesLifted, date, specialBoxCount, goldBoxesGotten } = args
        const { httpsCallable, functions } = await getFirebase()
        const status = await httpsCallable<CraneGameLevelData, boolean>(
          functions,
          'setCraneGameData',
        )({
          levelName,
          boxesDestroyed,
          boxesLifted,
          date,
          specialBoxCount,
          goldBoxesGotten,
        })
        return {
          data: status,
        }
      },
    }),
    setCraneGameShipState: build.mutation<unknown, ShipState>({
      queryFn: async (args) => {
        const { shipPosX, shipPosZ, shipRotation } = args
        const { httpsCallable, functions } = await getFirebase()
        const status = await httpsCallable(
          functions,
          'setCraneGameData',
        )({
          shipPosX,
          shipPosZ,
          shipRotation,
        })
        return {
          data: status,
        }
      },
    }),
  }),
})

export const { useSetCraneGameDataMutation, useSetCraneGameShipStateMutation } = craneGameApi
